import { axios, createFormData, handleError } from '../axios';

export const updateSetting = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post('admin/setting/options', createFormData(data))
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
